import { render, staticRenderFns } from "./shop_street.vue?vue&type=template&id=d8fcd700&scoped=true"
import script from "./shop_street.vue?vue&type=script&lang=js"
export * from "./shop_street.vue?vue&type=script&lang=js"
import style0 from "./shop_street.vue?vue&type=style&index=0&id=d8fcd700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fcd700",
  null
  
)

export default component.exports